module.exports = __webpack_public_path__ + "media/5.dc8b3fd3.mp4";